// Features/Product-Discount/Component.ts
class ProductDiscount extends HTMLElement {
  shadow;
  connectedCallback() {
    this.shade();
    this.listen();
  }
  async listen() {
    if (await this.canCopy) {
      const code = this.part_code;
      code.addEventListener("click", this.onCopy.bind(this));
      this.dataset.canCopy = String(true);
    }
  }
  shade() {
    if (this.attachInternals) {
      const internals = this.attachInternals();
      this.shadow = internals.shadowRoot;
      return;
    }
    const template = this.querySelector("template");
    this.shadow = this.attachShadow({ mode: "closed" });
    this.shadow.appendChild(template.content);
    template.remove();
  }
  get canCopy() {
    return navigator.permissions.query({ name: "clipboard-write" }).then((result) => result.state !== "denied").catch(() => true);
  }
  onCopy() {
    const copy = this.part_copy;
    if (copy.getAttribute("aria-hidden") == "false")
      return;
    navigator.clipboard.writeText(this.code);
    copy.setAttribute("aria-hidden", "false");
    setTimeout(() => {
      copy.setAttribute("aria-hidden", "true");
    }, 1800);
  }
  get code() {
    return this.dataset.code;
  }
  get part_code() {
    return this.query(`.Code`);
  }
  get part_copy() {
    return this.query(`.Copy`);
  }
  query(selector) {
    return this.shadow.querySelector(selector);
  }
}

// Features/Product-Discount/mod.ts
window.customElements.define("product-discount", ProductDiscount);
